export const convertName = (req) => {
    switch (req) {
        case 'username':
            return 'Kullanıcı Adı';
        case 'password':
            return 'Şifre';
        default:
            return req;
    }
};

export const convertReq = (req) => {
    let copy = {};
    req.forEach((req) => {
        copy[req] = '';
    });

    return copy;
};

// ZirveNova response'unu formatına çevirme fonksiyonları
export const convertZirveNovaResponseToLucaFormat = (zirveNovaData) => {
    return zirveNovaData.map((company) => ({
        company: {
            label: company.Klavuz,
            value: company.FrmId
        }
    }));
};

export const getCompanyForDropdown = (data) => {
    let company = [];
    data.forEach((item) => {
        company.push({
            title: item.company.label,
            value: item.company.value
        });
    });
    return company;
};

export const deleteCompanyIsHere = (data, company) => {
    let copy = [];
    data.forEach((item) => {
        if (company.find((c) => c.companyCode === item.value) === undefined) {
            copy.push(item);
        }
    });
    return copy;
};

export const sortReq = (req, sortArray) => {
    let sortedKeys = Object.keys(req).sort(function (a, b) {
        return sortArray.indexOf(a) - sortArray.indexOf(b);
    });

    return sortedKeys;
};

// ZirveNova'ya özel utility fonksiyonları
export const getZirveNovaCompanyForDropdown = (zirveNovaData) => {
    return zirveNovaData.map((company) => ({
        title: company.Klavuz,
        value: company.FrmId
    }));
};

// ZirveNova company bilgilerini almak için
export const getZirveNovaCompanyInfo = (zirveNovaData, companyId) => {
    return zirveNovaData.find((comp) => comp.FrmId === companyId);
};

// Şirket adını almak için
export const getCompanyTitle = (company) => {
    return company.Klavuz || '';
};
